exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._12KIY{cursor:pointer}span._2U9RZ,span._12KIY{font-size:16px;margin:0 8px}._2HePx{color:#777;font-style:italic}._9ygsD{background:#8b0000;color:#fff;font-weight:700}._9ygsD a{color:#fff!important;text-decoration:underline!important}.PkBOc{background:#f3d8d8;color:#8b0000}._34M0s{background:#f9fad2}._2VD8z{background:#d2e7fa}._1RTfg{padding:0!important}._1kT3X{padding:7px;line-height:24px}._92-f8{padding:7px 3px;line-height:30px}._10X4O div{overflow-x:hidden!important}._10X4O div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "_12KIY",
	"info": "_2U9RZ",
	"sinSnapshot": "_2HePx",
	"incumplimiento": "_9ygsD",
	"facturaCancelada": "PkBOc",
	"conCambios": "_34M0s",
	"conActualizaciones": "_2VD8z",
	"tdClear": "_1RTfg",
	"field": "_1kT3X",
	"fieldAsignacion": "_92-f8",
	"hidden": "_10X4O"
};